import { Button, Form, Input, Select, Upload } from 'antd'
import React from 'react'
import { t } from 'i18next'
import { UploadOutlined } from '@ant-design/icons'

export default function ProcedureForm ({ form, onFinish, actors, procedure }) {
  const initialValues = procedure ? { ...procedure } : {}
  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e[0].originFileObj
    }
    return e && e.fileList[0].originFileObj
  }

  const fileList = procedure?.file_info?.url
    ? [
        {
          name: procedure.file_info.name,
          url: procedure.file_info.url
        }
      ]
    : []

  return (
    <Form
      id="ProcedureForm"
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      style={{ width: '50%' }}
    >
      <Form.Item name='name' label={t('Admin.Procedure.attributes.name')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name='actors' label={t('Admin.Procedure.attributes.actors')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Select mode='multiple' options={actors} />
      </Form.Item>
      <Form.Item name='file' label={t('Admin.Procedure.attributes.file')} getValueFromEvent={getFile}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Upload
          beforeUpload={() => false}
          maxCount={1}
          showUploadList={{ showRemoveIcon: true }}
          defaultFileList={fileList}
          accept='.pdf'>
          <Button icon={<UploadOutlined />}>{t('actions.upload')}</Button>
        </Upload>
      </Form.Item>
    </Form >
  )
}
